(function () {
  function initDrawer() {
    var drawer = document.querySelector('[data-chike-drawer]');
    if (!drawer) return;

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    document.querySelectorAll('[data-chike-drawer-open]').forEach(function (button) {
      button.addEventListener('click', function () { setOpen(true); });
    });
    drawer.querySelectorAll('[data-chike-drawer-close]').forEach(function (button) {
      button.addEventListener('click', function () { setOpen(false); });
    });
    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) setOpen(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  function initSliders() {
    document.querySelectorAll('[data-chike-slider]').forEach(function (track) {
      var id = track.getAttribute('data-chike-slider');
      var controls = document.querySelector('[data-chike-slider-controls="' + id + '"]');
      if (!controls) return;
      var slides = Array.prototype.slice.call(track.children);
      var previous = controls.querySelector('[data-chike-prev]');
      var next = controls.querySelector('[data-chike-next]');
      var dots = controls.querySelector('[data-chike-dots]');
      var index = 0;

      function getMetrics() {
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap) || 0;
        var slideWidth = slides[0] ? slides[0].getBoundingClientRect().width : track.clientWidth;
        var step = slideWidth + gap;
        var visible = Math.max(1, Math.round((track.clientWidth + gap) / step));
        return { step: step, maxIndex: Math.max(0, slides.length - visible) };
      }

      function renderDots() {
        var maxIndex = getMetrics().maxIndex;
        dots.innerHTML = '';
        for (var dotIndex = 0; dotIndex <= maxIndex; dotIndex += 1) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'chike-slider-dot' + (dotIndex === index ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (dotIndex + 1));
          (function (targetIndex) {
            dot.addEventListener('click', function () { goTo(targetIndex); });
          })(dotIndex);
          dots.appendChild(dot);
        }
      }

      function goTo(newIndex) {
        var metrics = getMetrics();
        index = (newIndex + metrics.maxIndex + 1) % (metrics.maxIndex + 1);
        track.scrollTo({ left: metrics.step * index, behavior: 'smooth' });
        dots.querySelectorAll('.chike-slider-dot').forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      previous.addEventListener('click', function () { goTo(index - 1); });
      next.addEventListener('click', function () { goTo(index + 1); });
      renderDots();
      window.addEventListener('resize', function () {
        var maxIndex = getMetrics().maxIndex;
        index = Math.min(index, maxIndex);
        renderDots();
        goTo(index);
      });
    });
  }

  function initProduct() {
    var product = document.querySelector('[data-chike-product]');
    if (!product) return;
    var mainImage = product.querySelector('[data-chike-main-image]');
    var idInput = product.querySelector('[data-chike-variant-id]');
    var quantityInput = product.querySelector('[data-chike-quantity]');
    var selectedFlavor = product.querySelector('[data-chike-selected-flavor]');
    var galleryDots = Array.prototype.slice.call(product.querySelectorAll('[data-chike-gallery-dot]'));
    var galleryIndex = 0;
    var stickyBar = product.querySelector('[data-chike-sticky-atc]');
    var stickySelect = product.querySelector('[data-chike-sticky-variant]');
    var stickyImage = product.querySelector('[data-chike-sticky-image]');

    function activateImage(imageUrl, sourceButton, requestedIndex) {
      if (mainImage && imageUrl) mainImage.src = imageUrl;
      var matchedIndex = typeof requestedIndex === 'number' ? requestedIndex : galleryDots.findIndex(function (dot) {
        return dot.dataset.image === imageUrl;
      });
      if (matchedIndex >= 0) galleryIndex = matchedIndex;
      product.querySelectorAll('[data-chike-thumb]').forEach(function (thumb) {
        thumb.classList.toggle('is-active', Number(thumb.dataset.index) === galleryIndex || thumb === sourceButton);
      });
      galleryDots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === galleryIndex);
      });
    }

    product.querySelectorAll('[data-chike-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateImage(thumb.dataset.image, thumb, Number(thumb.dataset.index));
      });
    });

    galleryDots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { activateImage(dot.dataset.image, null, dotIndex); });
    });

    var galleryPrevious = product.querySelector('[data-chike-gallery-prev]');
    var galleryNext = product.querySelector('[data-chike-gallery-next]');
    if (galleryPrevious) {
      galleryPrevious.addEventListener('click', function () {
        var nextIndex = (galleryIndex - 1 + galleryDots.length) % galleryDots.length;
        activateImage(galleryDots[nextIndex].dataset.image, null, nextIndex);
      });
    }
    if (galleryNext) {
      galleryNext.addEventListener('click', function () {
        var nextIndex = (galleryIndex + 1) % galleryDots.length;
        activateImage(galleryDots[nextIndex].dataset.image, null, nextIndex);
      });
    }

    product.querySelectorAll('[data-chike-flavor]').forEach(function (button) {
      button.addEventListener('click', function () {
        product.querySelectorAll('[data-chike-flavor]').forEach(function (candidate) {
          candidate.classList.toggle('is-active', candidate === button);
          candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
        });
        if (idInput) idInput.value = button.dataset.variantId;
        if (selectedFlavor) selectedFlavor.textContent = button.dataset.variantTitle;
        if (stickySelect) stickySelect.value = button.dataset.variantId;
        if (stickyImage) stickyImage.src = button.dataset.image;
        activateImage(button.dataset.image, null);
      });
    });

    product.querySelectorAll('[data-chike-bundle]').forEach(function (bundle) {
      bundle.addEventListener('click', function () {
        var radio = bundle.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        product.querySelectorAll('[data-chike-bundle]').forEach(function (candidate) {
          candidate.classList.toggle('is-active', candidate === bundle);
        });
        if (quantityInput) quantityInput.value = bundle.dataset.quantity;
      });
    });

    function getItems() {
      var activeBundle = product.querySelector('[data-chike-bundle].is-active');
      var selects = activeBundle ? activeBundle.querySelectorAll('.chike-bundle-select') : [];
      var counts = {};
      if (selects.length) {
        selects.forEach(function (select) {
          counts[select.value] = (counts[select.value] || 0) + 1;
        });
      } else if (idInput && idInput.value) {
        counts[idInput.value] = Number(quantityInput && quantityInput.value ? quantityInput.value : 1);
      }
      return Object.keys(counts).map(function (id) {
        return { id: Number(id), quantity: counts[id] };
      });
    }

    function addBundle(destination, button) {
      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';
      var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: getItems() })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Unable to add this bundle.'); });
        return response.json();
      }).then(function () {
        window.location.href = destination;
      }).catch(function (error) {
        button.disabled = false;
        button.textContent = originalText;
        window.alert(error.message);
      });
    }

    var productForm = product.querySelector('.chike-product-form');
    if (productForm) {
      productForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = productForm.querySelector('[data-chike-add-to-cart]');
        addBundle(window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart', button);
      });
    }
    var buyNow = product.querySelector('[data-chike-buy-now]');
    if (buyNow) {
      buyNow.addEventListener('click', function () { addBundle('/checkout', buyNow); });
    }

    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var matchingFlavor = product.querySelector('[data-chike-flavor][data-variant-id="' + stickySelect.value + '"]');
        if (matchingFlavor) matchingFlavor.click();
      });
    }

    var stickyAdd = product.querySelector('[data-chike-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        addBundle(window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart', stickyAdd);
      });
    }

    if (stickyBar) {
      function updateStickyBar() {
        var visible = window.scrollY > product.offsetTop + 520;
        stickyBar.classList.toggle('is-visible', visible);
        stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
      updateStickyBar();
      window.addEventListener('scroll', updateStickyBar, { passive: true });
    }
  }

  function initNewsletter() {
    document.querySelectorAll('.chike-newsletter').forEach(function (form) {
      form.addEventListener('submit', function () {
        var button = form.querySelector('button');
        if (button) button.textContent = 'Signing up...';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initSliders();
    initProduct();
    initNewsletter();
  });
})();
